import React, { useMemo } from 'react'
import GrammatechCodeSonarCredentialForm from './GrammatechCodeSonarCredentialForm';
import GrammatechCodeSonarMappingForm from './GrammatechCodeSonarMappingForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function GrammatechCodeSonarConfigListing(props) {

    const extraColumns = useMemo(() => [
        {
            dataIndex: "applicationName",
            title: 'Application',
            width: 120
        }
    ],[]);

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={GrammatechCodeSonarMappingForm}
            CredentialsForm={GrammatechCodeSonarCredentialForm}
            extraColumns={extraColumns}
        />
    )
}